export default "__VITE_ASSET__D4ard4V9__"